import { constructs } from "../api/contructs";
import { CreateGenericReducer } from "./CreateGenericReducer";

export const PalettesReducer = CreateGenericReducer(constructs.palette);
